import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import BgImg from "../../images/locationgcc/hire-dubai/ideal_choice.webp";
import HtmlParser from "react-html-parser";

const idea = [
  {
    title: `Top <span>5%</span>`,
    subtit: "Utilizing Modern Technologies",
    txt: "We believe in continual innovation to give you a competitive edge in the market and that’s why we deploy the latest techniques in our app solutions.",
  },
  {
    title: "Top <span>10%</span>",
    subtit: "Expert Developers",
    txt: "Our priority remains to hire app developers in KSA from the top 10% of the experienced fleet, so we can ensure the maximum efficiency of our services.",
  },
  {
    title: "4.8<span>/5</span>",
    subtit: "Client Satisfaction Rating",
    txt: "We never compromise on client satisfaction, giving them a value-for-money outcome and our Clutch rating of 4.8 is living proof of our commitment.",
  },
];

function Idealchoice() {
  return (
    <div
      className="ideal_choice p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why We're the Ideal Choice to Hire App Developers and Make a
              Difference
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="ideal_dubai_box">
              {idea.map((item, index) => (
                <div className="ideal_box_item" key={index}>
                  <h2>{HtmlParser(item.title)}</h2>
                  <strong>{item.subtit}</strong>
                  <p>{item.txt}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Idealchoice;
